import { render, staticRenderFns } from "./RedirectEdit.vue?vue&type=template&id=94727e4c"
import script from "./RedirectEdit.vue?vue&type=script&lang=js"
export * from "./RedirectEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports